import React, { useEffect } from "react";
import { Form, Input, Collapse } from 'antd';
import Button from "components/button";
import { buildFilters } from "../../utils/index";
import AddressFilter from "components/search/AddressFilter";
import { useForm } from "antd/lib/form/Form";
import FormItem from "components/fields/FormItem";
import APIService from '../../services/apiservice';


function ModuleSearchFilter(props) {
  	const { placeholder, searchHandler, pagination, defaultFilters={}, filters, filterName, resetHandler } = props;
  	const [form] = useForm();
  
  	useEffect(() => {
		if (filters) {
			form.setFieldsValue(filters);
		}
	}, [filters, form]);

	useEffect(() => {
		doSearch(defaultFilters);
	}, [searchHandler, pagination.per_page]);

	const onSubmit = (formData) => {
		doSearch({page: 1, paginate: pagination.per_page, ...formData});
	}

	const doSearch = (params) => {
		const filterData = buildFilters({
			...filters,
			...params,
		});
		APIService.setPageFilters(filterName, filterData);
		searchHandler(filterData);
	}

	const resetFilters = () => {
		form.resetFields();
		APIService.setPageFilters(filterName, {});
		resetHandler ? resetHandler() : searchHandler({page: 1, paginate: pagination.per_page});	
	}
    
  return (
  	<Form form={form} className="mb-4 bg-white rounded-md dark:bg-intsamis-900"
		layout="vertical"
		onFinish={onSubmit}
	>
		<div className="flex flex-col md:flex-row md:justify-between gap-4 mb-4">
			<FormItem 
				name="keyword"
				label={null}
				noStyle={true}
			>
				<Input.Search
					placeholder={placeholder ?? "Search keyword"}
					enterButton
					onSearch={() => form.submit()}
					style={{ width: 300 }}
					size="large"
					allowClear={true}
				/>
			</FormItem>
			
		</div>
		<div className="mt-3">
		<Collapse
			size="large"
			items={
			[{ key: '1', 
				label: <h4 className="font-bold">Filter By Location</h4>, 
				children: 
					<div>
						<AddressFilter className="form-column-4" form={form} filters={filters}/> 
						<div className="dark:bg-intsamis-900 text-right mt-4">
							<Button type="button" className="mx-3 min-w-[100px] text-center " onClick={resetFilters}>
								Reset
							</Button>
							<Button type="submit" className="mx-3 min-w-[100px] text-center ">
								Apply
							</Button>
						</div>
					</div>
				}
			]
			}
		/>
		</div>
		
	</Form>
  );
}

export default ModuleSearchFilter;
